module.exports = __webpack_public_path__ + "img/5c666ea3-a24a-4969-996b-7b7b11f3cef9.47ed6b90.png";